

























import { defineComponent, ref } from '@vue/composition-api';
import OlbButton from '../button/button.vue';
import OlbIcon from '../icon/icon.vue';
import { ResponsiveUtils } from '../../utils';
import Vue from 'vue';
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

/**
 * Simple component to display content full screen in a dialog.
 * E.g. useful to show an image fullsize.
 *
 * **CAUTION:** The contents can't have a fixed width! If the content should have a fixed width in non-zoomed state,
 * you have to set the appropriate (Tailwind-)classes either on the `olb-zoom` tag or its parent elements.
 * Otherwise, the contents won't be displayed fullsize!
 */
export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
	},
	props: {
		enableMobileZoom: {
			type: Boolean,
			default: false,
		},
		dialogClasses: {
			type: String,
		},
	},
	setup(props, { slots }) {
		const responsiveUtils = new ResponsiveUtils();
		const isOpen = ref(false);
		const dialogContent = ref<HTMLDivElement | null>();

		function toggleDialog() {
			if (!props.enableMobileZoom && responsiveUtils.isMdDown()) {
				return;
			}
			isOpen.value = !isOpen.value;
		}

		/**
		 * Fill the dialog's content with the zoomed content, if not already filled.
		 */
		function fillWithContent() {
			if (!dialogContent.value?.childNodes.length && slots.default().length) {
				const slotContent = slots.default()[0].elm?.cloneNode(true);
				slotContent && dialogContent.value?.appendChild(slotContent);
			}
		}

		return { isOpen, toggleDialog, dialogContent, fillWithContent };
	},
});
